import { all } from "redux-saga/effects";
import contentSaga from "./content";
// ✨ voiceSaga removed - migrated to React Query + Zustand
// ✨ organisationSaga removed - migrated to React Query
import integrationSaga from "./integration";
import editContentSaga from "./edit_content";
import audioComposerSaga from "./audio_composer";
import mixpanelSaga from "./mixpanel";

export default function* rootSaga() {
  yield all([
    contentSaga(),
    // voiceSaga(), // ✨ Removed - voice functionality migrated to React Query hooks + Zustand
    integrationSaga(),
    // organisationSaga(), // ✨ Removed - organisation data & usage migrated to React Query
    editContentSaga(),
    audioComposerSaga(),
    mixpanelSaga()
  ]);
}